import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { DropDownMenu, MenuItem, RaisedButton, TextField, RefreshIndicator } from "material-ui"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import * as api from "../../api"
import HtmlLoader from "../../components/layout/HtmlLoader"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import { IAccountRegistraionDTO } from "../../models"
import { BrowserView, MobileView } from "react-device-detect"
import { browserHistory } from "react-router"
import NoMatch from "../NoMatch"

interface IState {
    allValid: boolean
    accountName: string
    accountNameErrorText: string
    typeOfBusiness: number
    sizeOfBusiness: number
    workPhone: string
    saveValidate: boolean
    savingAccount: boolean
    recaptchaResponse: string
    recaptchaErrorText: string
}

export default class AccountRegistrationInfo extends React.Component<null, IState> {
    constructor(props) {
        super(props)
        this.state = {
            allValid: false,
            accountName: "",
            accountNameErrorText: "",
            typeOfBusiness: -1,
            sizeOfBusiness: -1,
            workPhone: null,
            saveValidate: false,
            savingAccount: false,
            recaptchaResponse: null,
            recaptchaErrorText: null
        }
        autobind(this)
    }

    componentDidMount() {
        document.title = `Register Info | ${strings.Findd_Grandd_Central}`
        window["grecaptcha"] &&
            window["grecaptcha"].render('recaptcha', { 'sitekey': '6Lfy2dEdAAAAAE2aS0-SCZokGVBFq4qYaTKyJVMc' })
        document.addEventListener('recaptcha', this.onReCaptchaChange)
        AccountStore.setMarketingDetails(new URLSearchParams(location.search))
    }

    componentWillUnmount() {
        document.removeEventListener('recaptcha', this.onReCaptchaChange)
    }

    onReCaptchaChange() {
        this.checkValidate(true)
    }

    checkValidate(onSave: boolean = false) {
        let returnVal = true

        if (this.state.accountName.length === 0) {
            returnVal = false
        }

        if (this.state.typeOfBusiness < 0) {
            returnVal = false
        }

        if (this.state.sizeOfBusiness < 0) {
            returnVal = false
        }

        this.setState({ recaptchaResponse: window["grecaptcha"].getResponse() }, () => {
            if (!this.state.recaptchaResponse) {
                this.setState({ allValid: false })
                if (onSave) {
                    this.setState({ recaptchaErrorText: "Please click on \"I'm not a robot\" checkbox before logging in" })
                }
            } else {
                this.setState({ recaptchaErrorText: null, allValid: returnVal })
            }
        })
    }

    saveAccount() {
        this.checkValidate(true)
        if (this.state.allValid) {
            this.setState({ savingAccount: true }, () =>
                this.addNewAccount()
            )
        }
    }

    addNewAccount() {
        const accountRegistrationDTO = {
            AccountName: this.state.accountName,
            Email: AppStateStore.registrationEmail,
            FirstName: AppStateStore.registrationUserFirstName,
            LastName: AppStateStore.registrationUserLastName,
            CompanyType: this.state.typeOfBusiness,
            CompanySize: this.state.sizeOfBusiness,
            RecaptchaResponse: this.state.recaptchaResponse,
            SendWelcomeEmail: true,
            DefaultIANATimezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
            MarketingInfo: AccountStore.getMarketingInfoFromLocalStorage(),
            PhoneNumber: this.state.workPhone,
        } as IAccountRegistraionDTO

        api.accountRegistration(accountRegistrationDTO).then(() =>
            browserHistory.replace("account_registration_completed")
        )
    }

    render() {
        if (!AppStateStore.registrationUserFirstName || !AppStateStore.registrationUserLastName || !AppStateStore.registrationEmail)
            return <NoMatch />

        return (
            <RegistrationLayout
                leftContainer={
                    <div>
                        <BrowserView>
                            <h1>Tell us more about your company</h1>
                        </BrowserView>
                        <MobileView>
                            <h2>Tell us more about your company</h2>
                        </MobileView>
                        <div>
                            <h3>What is the name of your company?</h3>
                            <TextField
                                floatingLabelText={strings.AccountName}
                                value={this.state.accountName}
                                autocomplete="off"
                                onChange={(e, value) => this.setState({ accountName: value }, () => this.checkValidate())}
                                style={{ width: "100%", marginTop: -25, marginLeft: 20 }}
                                autoFocus
                            />
                            <h3>What type of business are you?</h3>
                            <DropDownMenu value={this.state.typeOfBusiness} onChange={(e, index, value) => this.setState({ typeOfBusiness: value }, () => this.checkValidate())} style={{ width: "100%" }}>
                                <MenuItem value={-1} primaryText={"Select the industry of your business"} key={-1} />
                                <MenuItem value={1} primaryText={"Building Services and Maintenance"} key={1} />
                                <MenuItem value={2} primaryText={"Construction"} key={2} />
                                <MenuItem value={3} primaryText={"Healthcare"} key={3} />
                                <MenuItem value={4} primaryText={"Janitorial"} key={4} />
                                <MenuItem value={5} primaryText={"Manufacturing"} key={5} />
                                <MenuItem value={6} primaryText={"Security"} key={6} />
                                <MenuItem value={7} primaryText={"Temp Staffing"} key={7} />
                                <MenuItem value={8} primaryText={"Other"} key={8} />
                            </DropDownMenu>

                            <h3>How many employees do you have?</h3>
                            <div>
                                <DropDownMenu value={this.state.sizeOfBusiness} onChange={(e, index, value) => this.setState({ sizeOfBusiness: value }, () => this.checkValidate())} style={{ width: "100%" }}>
                                    <MenuItem value={-1} primaryText={"Select the size of your business"} key={-1} />
                                    <MenuItem value={0} primaryText={"0-10"} key={0} />
                                    <MenuItem value={1} primaryText={"10-50"} key={1} />
                                    <MenuItem value={2} primaryText={"50-250"} key={2} />
                                    <MenuItem value={3} primaryText={"250-500"} key={3} />
                                    <MenuItem value={4} primaryText={"500-1500"} key={4} />
                                    <MenuItem value={5} primaryText={"1500+"} key={5} />
                                    <MenuItem value={6} primaryText={"> 10,000"} key={6} />
                                </DropDownMenu>
                            </div>

                            <h3>What's your business phone number?</h3>
                            <TextField
                                floatingLabelText={strings.Work_Phone}
                                value={this.state.workPhone || ""}
                                onChange={(_e, workPhone) => this.setState({ workPhone }, () => this.checkValidate())}
                                style={{ width: "100%", marginTop: -25, marginLeft: 20 }}
                            />
                        </div>
                        {!this.state.savingAccount &&
                            <div>
                                <div style={{ marginTop: 50 }}>
                                    <div id="recaptcha" style={{ width: "100%" }} data-callback="recaptchaChangeEvent" />
                                    <div style={{ fontSize: "12px", color: "#F44336" }}>{this.state.recaptchaErrorText}</div>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    <RaisedButton
                                        data-intercom-target={"AccountManagerDrawer-Btn-save"}
                                        disabled={!this.state.allValid}
                                        backgroundColor="#1181F2"
                                        labelColor="white"
                                        label={strings.Finish}
                                        onTouchTap={() => this.saveAccount()}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                            </div>
                        }
                        {this.state.savingAccount &&
                            <div style={{ marginTop: 50, textAlign: "center" }}>
                                <RefreshIndicator
                                    size={35}
                                    status="loading"
                                    style={{ position: "static", display: "block", margin: "0 auto" }}
                                />
                            </div>
                        }
                    </div>
                }
                rightContainer={
                    <div style={{ color: "white", padding: 50 }}>
                        <HtmlLoader htmlUrl="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/account_registration.html" />
                    </div>
                }
                loading={null}
                frontEndSettings={AppStateStore.getFrontEndSettings()}
            />
        )
    }
}